/**
 * ReportUsersTemplate entity class
 */

/**
 * ReportUsersTemplateFactory
 * returns ReportUsersTemplate entity class
 *
 * @class ReportUsersTemplateFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportUsersTemplate} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportUsersTemplateFactory
 */
/* @ngInject */
export default function ReportUsersTemplateFactory ($http, ReportTemplate, onOffMixin, alertLiteSvc) {
  /* === ReportUsersTemplate class === */

  /**
   * ReportUsersTemplate model
   *
   * @class ReportUsersTemplate
   * @classdesc ReportUsersTemplate model
   * @memberof models
   * @see models
   * @extends models.ReportTemplate
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportUsersTemplate entity fields
   * @return {models.ReportUsersTemplate} ReportUsersTemplate entity
   */
  function ReportUsersTemplate () {
    var obj = ReportTemplate.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportUsersTemplate.prototype = Object.create(ReportTemplate.prototype)
  ReportUsersTemplate.prototype.constructor = ReportUsersTemplate

  /* === User instance methods & fields === */

  Object.assign(ReportUsersTemplate.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportUsers#
     * @type {Object}
     */
    _fields: {
      autoPayEnabled: Boolean,
      availableAllSubscriptions: Boolean,
      createdBy: String,
      createdTime: String,
      id: Number,
      name: String,
      includeCustomSubscriptions: Boolean,
      networks: [],
      paymentSystemTypes: [],
      periodAmount: Number,
      periodType: String,
      reportType: String,
      subscriptionFromDays: Number,
      subscriptionToDays: Number,
      subscriptionFromMonth: Number,
      subscriptionToMonth: Number,
      subscriptions: [],
      users: []
    },

    /**
     * url template
     *
     * @memberof models.ReportUsersTemplate#
     * @type {String}
     */
    _urlTemplate: 'api/reports/users/activations/templates/{{::id}}',

    /**
     * Generate template
     *
     * @private
     */
    _generate: function () {
      return $http.post(
        this._url,
        {templateId: this.id}
      ).catch(alertLiteSvc.alertError)
    }

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from ReportTemplate class
  Object.assign(ReportUsersTemplate, ReportTemplate)
  ReportUsersTemplate._name = 'ReportUsersTemplate'
  ReportUsersTemplate.init()

  // permissions
  // ReportUsersTemplate.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportUsersTemplate
}
